import { useState, useEffect, useRef, useContext } from 'react'
import { Notification } from 'types/Notification'
import ServicesContext from 'Contexts/Services/Services.context'
import { useDispatch } from 'react-redux'
import { NotificationAction } from 'State/Store/Notification/Notification.reducer'

const NOTIFICATION_CHECK_INTERVAL_IN_MS = 60000

export function useNotifications(activeNotification: Notification | null) {
  const intervalRef = useRef<any>(null)
  const dispatch = useDispatch()
  const services = useContext(ServicesContext)

  const refresh = async () => {
    try {
      const result = await services.notificationService.getNotifications(100)
      if (Array.isArray(result.notifications)) {
        dispatch(NotificationAction.setNotifications(result.notifications))
      }
    } catch (e) {
      //
    }
  }

  useEffect(() => {
    const checkForNotifications = () => {
      if (activeNotification === null) {
        refresh()
      }
    }
    checkForNotifications()

    if (!intervalRef.current) {
      // set interval to check for notifications periodically, for once once
      intervalRef.current = setInterval(checkForNotifications, NOTIFICATION_CHECK_INTERVAL_IN_MS)
    }

    return () => {
      clearInterval(intervalRef.current) // clear interval
      intervalRef.current = null
    }
  }, [activeNotification])

  return { refresh }
}
